export const EMAIL_COMMON_STYLES = {
  GRAY_COLOR: '#757575',
  TABLE_ATTRS: `border="0" width="100%" cellpadding="0" cellspacing="0" align="left"`,
  SECTION_TITLE_STYLE: `font-size: 18px; padding-bottom: 8px`
};
